import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  class: "gfu-credit-card-overview gfu-credit-card-overview--pledge",
  "data-qa": "card-overview"
}
const _hoisted_2 = { class: "_flex _gap-1 _ai-c" }
const _hoisted_3 = {
  class: "gfu-credit-card-overview__label",
  "data-qa": "payment-method-label"
}
const _hoisted_4 = {
  key: 0,
  class: "_ml-1"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_image, {
        src: $options.paymentImageUrl,
        alt: $options.altText,
        "data-qa": "card-image"
      }, null, 8 /* PROPS */, ["src", "alt"]),
      _createElementVNode("span", _hoisted_3, _toDisplayString($options.paymentMethodLabel), 1 /* TEXT */),
      ($options.externalPaymentDataSource)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString($options.externalPaymentDataSource) + ")", 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}